import React, { useState, useRef } from "react";
import {
  WithdrawButton,
  WithdrawCard,
  WithdrawContainer,
  WithdrawInput,
} from "./Withdraw.styled";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { WITHDRAWAL_CHARGE_FEE, WITHDRAWAL_PERCENTAGE } from "../../constants";
import SuccessPage from "../SuccessPage/SuccessPage";
import { MIN_AMOUNT } from "../../constants";
import { FormWrapper } from "../Auth.styled";
import PinModal from "./PinModal";
import { getWithdrawalPin } from "../../feature/withdraw/WithdrawActions";
import { Link } from "react-router-dom";

const Withdraw = () => {
  const [showPinModal, setShowPinModal] = useState(false);
  const [withdrawalPinModal, setWithdrawalPinModal] = useState(false);
  const [withdrawn, setWithdrawn] = useState(false);
  const inputRef = useRef(null);
  const dispatch = useDispatch();

  const { balance } = useSelector((state) => state.wallet);

  const handlePaste = () => {
    const clipboardData = navigator.clipboard;
    clipboardData.readText().then((pastedText) => {
      formik.setFieldValue("withdrawal_address", pastedText);
    });
  };

  const initialValues = {
    withdrawal_address: "",
    amount: "",
  };

  const onSubmit = (values) => {
    dispatch(getWithdrawalPin({}))
      .unwrap()
      .then((res) => setShowPinModal(true))
      .catch((error) => setWithdrawalPinModal(true));
  };

  const validationSchema = Yup.object({
    withdrawal_address: Yup.string()
      .matches(/^T[1-9A-HJ-NP-Za-km-z]{33}$/, "Invalid Tron address")
      .required("Address is required"),
    amount: Yup.number()
      .min(MIN_AMOUNT, `amount must be greater than ${MIN_AMOUNT}`)
      .max(balance, `amount must be less or equal to ${balance}`)
      .required("amount is required"),
  });

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
  });

  return (
    <>
      {withdrawn ? (
        <SuccessPage
          message="Withdrawal Successful"
          links={[{ link: "/balance", name: "Balance" }]}
        />
      ) : (
        <>
          <WithdrawContainer>
            <WithdrawCard>
              <form onSubmit={formik.handleSubmit}>
                <FormWrapper>
                  <WithdrawInput
                    ref={inputRef}
                    type="text"
                    name="withdrawal_address"
                    placeholder="Withdrawal Address (TRX)"
                    onChange={formik.handleChange}
                    value={formik.values.withdrawal_address}
                    autoComplete="chrome-off"
                  />
                  <button
                    type="button"
                    style={{
                      marginInlineStart: "-80px",
                      height: "30px",
                      width: "80px",
                      borderRadius: 0,
                    }}
                    onClick={handlePaste}
                  >
                    Paste
                  </button>
                </FormWrapper>
                <>
                  {formik.errors.withdrawal_address ? (
                    <div style={{ color: "tomato", margin: 0 }}>
                      {formik.errors.withdrawal_address}
                    </div>
                  ) : null}
                </>
                <FormWrapper>
                  <WithdrawInput
                    type="number"
                    pattern="\d*"
                    placeholder="Amount"
                    name="amount"
                    onChange={formik.handleChange}
                    value={formik.values.amount}
                  />
                  <button
                    type="button"
                    style={{
                      marginInlineStart: "-80px",
                      height: "30px",
                      width: "80px",
                      borderRadius: 0,
                    }}
                    onClick={() => {
                      formik.setFieldValue("amount", balance);
                    }}
                  >
                    MAX
                  </button>
                </FormWrapper>
                <div style={{ fontSize: "10px" }}>
                  Fee{" "}
                  {(
                    (formik.values.amount * WITHDRAWAL_PERCENTAGE) /
                    100
                  ).toFixed(2)}{" "}
                  + {WITHDRAWAL_CHARGE_FEE.toFixed(2)} TRX
                </div>
                <>
                  {formik.errors.amount ? (
                    <div style={{ color: "tomato", margin: 0 }}>
                      {formik.errors.amount}
                    </div>
                  ) : null}
                </>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-evenly",
                    alignItems: "center",
                    fontSize: "10px",
                    margin: "20px auto",
                    border: "1px solid rgba(255, 255, 255, 0.2)",
                    padding: "5px",
                  }}
                >
                  <span>Withdrawal amount after fee:</span>
                  <span>{`${(
                    formik.values.amount -
                    (formik.values.amount * WITHDRAWAL_PERCENTAGE) / 100 -
                    WITHDRAWAL_CHARGE_FEE
                  ).toFixed(2)} TRX`}</span>
                </div>
                <h6
                  style={{
                    textAlign: "center",
                    marginInline: "auto",
                  }}
                >
                  Withdrawal takes 10 - 15 minutes to process. Please confirm
                  that the above information is correct before proceeding. We
                  won't be responsible for any lost asset if sent to the wrong
                  address.
                </h6>

                <WithdrawButton type="submit">Withdraw</WithdrawButton>
              </form>
            </WithdrawCard>
          </WithdrawContainer>
          <PinModal
            showPinModal={showPinModal}
            setShowPinModal={setShowPinModal}
            setWithdrawn={setWithdrawn}
            amount={formik.values.amount}
            withdrawal_address={formik.values.withdrawal_address}
          />
          <div
            style={{
              display: `${withdrawalPinModal ? "flex" : "none"}`,
              position: "fixed",
              width: "100vw",
              marginInline: "auto",
              top: 0,
              left: 0,
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
            }}
          >
            <div
              style={{
                background: "#000",
                border: "1px solid #7B36EE",
                borderRadius: "10px",
                marginInline: "15px",
                padding: "15px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "80%",
              }}
            >
              <div
                onClick={() => setWithdrawalPinModal(false)}
                style={{
                  display: "flex",
                  alignSelf: "self-end",
                  cursor: "pointer",
                }}
              >
                X
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ marginBlock: "10px" }}
                >
                  <path
                    d="M16.6668 11.6694C16.6668 11.4925 16.5966 11.323 16.4716 11.1979C16.3465 11.0729 16.177 11.0027 16.0002 11.0027C15.8234 11.0027 15.6538 11.0729 15.5288 11.1979C15.4037 11.323 15.3335 11.4925 15.3335 11.6694V19.6694C15.3335 19.8462 15.4037 20.0157 15.5288 20.1408C15.6538 20.2658 15.8234 20.336 16.0002 20.336C16.177 20.336 16.3465 20.2658 16.4716 20.1408C16.5966 20.0157 16.6668 19.8462 16.6668 19.6694V11.6694Z"
                    fill="#F0BCBC"
                  />
                  <path
                    d="M15.9987 22.9813C16.3669 22.9813 16.6654 22.6828 16.6654 22.3146C16.6654 21.9464 16.3669 21.6479 15.9987 21.6479C15.6305 21.6479 15.332 21.9464 15.332 22.3146C15.332 22.6828 15.6305 22.9813 15.9987 22.9813Z"
                    fill="#F0BCBC"
                  />
                  <path
                    d="M24.8558 27.9119H7.1798C6.60842 27.9117 6.04669 27.7646 5.54852 27.4848C5.05036 27.205 4.63249 26.8018 4.33502 26.3139C4.03755 25.8261 3.87048 25.27 3.84983 24.699C3.82919 24.128 3.95567 23.5613 4.21713 23.0532L13.0558 5.89455C13.3363 5.3506 13.7611 4.89437 14.2837 4.57586C14.8063 4.25736 15.4065 4.08887 16.0185 4.08887C16.6305 4.08887 17.2307 4.25736 17.7532 4.57586C18.2758 4.89437 18.7007 5.3506 18.9811 5.89455L27.8198 23.0532C28.0813 23.5614 28.2078 24.1282 28.1871 24.6993C28.1664 25.2704 27.9992 25.8266 27.7016 26.3145C27.4039 26.8024 26.9859 27.2055 26.4875 27.4853C25.9892 27.765 25.4273 27.9119 24.8558 27.9119ZM16.0185 5.41988C15.6502 5.41651 15.2883 5.51641 14.974 5.70825C14.6596 5.90008 14.4052 6.17618 14.2398 6.50522L5.40246 23.6639C5.24572 23.9687 5.16993 24.3086 5.18237 24.6511C5.19481 24.9936 5.29505 25.3272 5.47349 25.6198C5.65192 25.9124 5.90256 26.1543 6.20135 26.3222C6.50014 26.49 6.83707 26.5783 7.1798 26.5785H24.8558C25.1986 26.5786 25.5357 26.4904 25.8347 26.3227C26.1337 26.1549 26.3845 25.913 26.5631 25.6204C26.7417 25.3277 26.842 24.9941 26.8545 24.6515C26.867 24.3088 26.7913 23.9688 26.6345 23.6639L17.7971 6.50522C17.6317 6.17618 17.3774 5.90008 17.063 5.70825C16.7486 5.51641 16.3867 5.41651 16.0185 5.41988Z"
                    fill="#F0BCBC"
                  />
                </svg>
                <Link to="/set-withdrawal-pin">Set Withdrawal Pin</Link>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Withdraw;
